import Box from '@mui/material/Box';
import {
    Button, CircularProgress, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer,
    TableRow, Typography, useMediaQuery
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import CloseIcon from '@mui/icons-material/Close';
import { TempPartnerSignup } from '../../../app/models/partners';
import { adminUserStyles } from '../adminUsers/adminUserStyles';

interface Propsaaa {
    partnerData: TempPartnerSignup;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        // bgcolor: 'background.paper',
        bgcolor: '#B6DAFF',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        // height: isMobile ? 650 : 800,
    })
};

const AdminPartnerTempDeleteModal = ({ partnerData }: Propsaaa) => {

    const { modalStore, partnerStore } = useStore();
    const { closeModal } = modalStore;
    const { deleteEmailTempSignup, deleteEmailTempLoading } = partnerStore;

    const matches = useMediaQuery('(min-width:900px)');

    const closeModalHandler = () => {
        closeModal();
    }
    const deleteSignUpHandler = (id: string) => {
        deleteEmailTempSignup(id);
        closeModal();
    }
    if (!partnerData)
        return null;
    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center'>{partnerData.username}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table" >
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Are you sure, you want to delete this user : {partnerData.emailId}<br />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {!deleteEmailTempLoading ?
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            pt={2}
                        >
                            <Button variant='contained' onClick={() => deleteSignUpHandler(partnerData.id)}>Delete</Button>
                            <Button size={matches ? "medium" : "small"} variant="contained" onClick={closeModalHandler}
                                startIcon={<CloseIcon />}>Close</Button>
                        </Stack>
                        : <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            pt={2}
                        >
                            <CircularProgress size='1.2em' />
                        </Stack>
                    }
                </Grid>
            </Grid>
        </Box>
    )
}
export default observer(AdminPartnerTempDeleteModal);